import { gql, useQuery } from "@apollo/client";
import { useMemo } from "react";

const GetNewTeacherIdsQuery = gql`
  query getNewTeacherIds($checks: [NewTeacherCheckInput!]!) {
    getNewTeacherIds(checks: $checks)
  }
`;

type NewTeacherCheck = {
  teacherId: string;
  createdAt: string;
};

export function useNewTeacherIds(checks: NewTeacherCheck[]) {
  const { data, loading } = useQuery(GetNewTeacherIdsQuery, {
    variables: { checks },
    skip: checks.length === 0,
    fetchPolicy: "cache-and-network",
  });

  const newTeacherIds = useMemo(() => {
    return new Set<string>(data?.getNewTeacherIds ?? []);
  }, [data]);

  return { newTeacherIds, loading };
}
